export const state = {
  bonds: [],
  systemBond: [],
  custombonds: [],
  systemCustombond: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/bonds/state.js